// extracted by mini-css-extract-plugin
export var label = "Input-module--label--f2227";
export var error = "Input-module--error--b9de0";
export var placeholder = "Input-module--placeholder--1e5cf";
export var withPrependedTooltip = "Input-module--withPrependedTooltip--c5933";
export var scrollbarShow = "Input-module--scrollbarShow--357df";
export var withIcon = "Input-module--withIcon--cdf3e";
export var inputIcon = "Input-module--inputIcon--72c50";
export var closeButton = "Input-module--closeButton--dfee1";